import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import { Drawer } from "@mui/material"
import { RoomFinder } from "./RoomFinder"

const useStyles = makeStyles()(() => ({
    drawer: {
        width: "40rem",
        overflow: "auto",
        backgroundColor: tailwindPalette.slate[50],
        padding: "2rem",
    },
}))

export function RoomFinderDrawer({
    open,
    onClose,
    openSuccessDialog,
}: {
    open: boolean
    onClose: () => void
    openSuccessDialog: (orderId: number) => void
}) {
    const { classes } = useStyles()

    return (
        <Drawer
            open={open}
            anchor="right"
            PaperProps={{
                className: classes.drawer,
            }}
            onClose={onClose}
        >
            <RoomFinder openSuccessDialog={openSuccessDialog} onClose={onClose} />
        </Drawer>
    )
}
